<template>
  <div class="insertionOrderOuterWrapper">
    <div class="insertionOrderWrapper">
      <div v-if="!automaticLineItemRetrieve" class="itemWrapper manualLineItemRetrieve">
        <div class="items">
          <!--<InputFloatLabel
                  icon-size="1.8em" :value="site" label="Sites" icon="icon-add" @click="this.addSite"
                  @enter="this.addSite" @input="siteInput">
          </InputFloatLabel>-->
          <combo-box v-if="type!=='Festplatzierung'" :editable="false" icon="icon-add"
                     :insertion-order-index="index" :medium-index="mediumIndex" :items="this.allSites"
                     label="Sites" @enter="this.addSite" value="site"></combo-box>
          <InputDetail v-if="type==='Festplatzierung'"
                       label="Sites"
                       icon="icon-sites"
                       :iconBorder="true"
                       icon-size="1.8em"
                       @focus="openSitesDialog"
                       @click="openSitesDialog"
          ></InputDetail>
          <Dialog :has-backdrop="true" :show="showSitesDialog" @close="closeSitesDialog"
                  :show-close-button="true">
            <div style="min-width: 800px">
              <h4 class="dialogHeader">Units zusammenstellen und hinzufügen</h4>
              <div class="dropdownWrapperSites">
                <div class="combobox">
                  <combo-box :select-on-click="true" :editable="false"
                             :insertion-order-index="index"
                             :medium-index="mediumIndex" :items="this.allSites"
                             label="First Level Unit"
                             @enter="getSecondLevels" value="site"></combo-box>
                </div>
                <div class="combobox">
                  <combo-box v-if="categories.length!==0" :editable="false"
                             :select-on-click="true"
                             :insertion-order-index="index+categories.length"
                             :medium-index="mediumIndex" :items="this.categories"
                             label="Second Level Unit" @enter="changeSecondLevelSite"
                             value="site"></combo-box>
                </div>
                <span class="combobox"
                      v-if="categories.length===0 && !categoriesLoading">Keine Kategorien</span>
                <div v-if="categoriesLoading" class="loader"></div>
                <div style="display: inline-block;float: right;">
                  <SubmitButton class="combobox"
                                :custom-styles="{backgroundColor:'#00b6ed',borderColor:'#00b6ed'}"
                                type="createButton" title="UNIT ERSTELLEN" @click="addSecondLevelSite"
                                icon="icon-add"></SubmitButton>
                </div>
                <div class="createdContainer">
                  <span>Erstellte Units</span>
                  <div class="bubbleContainer secondLevelBubbles">
                    <InfoBubble @bubbleDeleted="deleteSite($event, siteIndex)"
                                v-for="(singleSite, siteIndex) in this.sites"
                                :key="mediumIndex+'-'+index+'-'+singleSite.name+'-dialog'"
                                color="pink" :isFilled=true
                                :value="singleSite.parent_name ?singleSite.parent_name+ ' ' +singleSite.name:singleSite.name"></InfoBubble>
                  </div>
                </div>
                <SubmitButton class="combobox submitSecondLevelSites"
                              type="createButton" title="Bestätigen"
                              icon="icon-apply" @click="closeSitesDialog"></SubmitButton>
              </div>
            </div>


          </Dialog>
          <div v-if="this.siteValidationLoading" class="loader"></div>
          <div class="bubbleContainer">
            <InfoBubble @bubbleDeleted="deleteSite($event, siteIndex)" v-for="(singleSite, siteIndex) in this.sites"
                        :key="mediumIndex+'-'+index+'-'+(singleSite.parent_name ?singleSite.parent_name+ ' ' +singleSite.name:singleSite.name)"
                        color="pink" :isFilled=true
                        :value="singleSite.parent_name ?singleSite.parent_name+ ' ' +singleSite.name:singleSite.name"></InfoBubble>
            <InfoBubble v-for="singleSite in this.invalidSites" :key="mediumIndex+'-'+index+'-'+singleSite"
                        color="red" :isFilled=true :value="singleSite"
                        icon="icon-status-alarm"></InfoBubble>
          </div>
        </div>
        <div class="items">
          <DatePicker
              :info-text="type==='Festplatzierung'?'<b>Hinweis</b>: Bei Festplatzierungen bitte immer noch den Folgetag auswählen, da Buchungstage hier von 10 Uhr bis 10 Uhr des nächsten Tages gehen.':''"
              @close="datePickerClosed"></DatePicker>
          <div class="bubbleContainer">
            <InfoBubble @bubbleDeleted="deleteRange" v-for="date in this.dates"
                        :key="mediumIndex+'-'+index+'-'+date.start+'-'+date.end" color="blue" :isFilled=true
                        :value="formatDate(date.start) + ' - ' + formatDate(date.end)"></InfoBubble>
          </div>
          <div v-if="adSpecial === 28" class="additionalDates bubbleContainer">
            <div class="dashboard-date-heading"><span>Dashboard Laufzeit hinzufügen:</span>
              <DatePicker class="icon" :only-icon="true"
                          @close="dashboardDatePickerClosed"></DatePicker>
            </div>
            <InfoBubble @bubbleDeleted="deleteDashboardRange" v-for="date in this.dashboard_dates"
                        :key="'dashboard-'+mediumIndex+'-'+index+'-'+date.start+'-'+date.end" color="blue"
                        :isFilled=true
                        :value="formatDate(date.start) + ' - ' + formatDate(date.end)"></InfoBubble>
          </div>
        </div>

        <div class="items">
          <InputFloatLabel
              icon-size="1.8em" :value="this.lineItemId" label="AdManager LineItem IDs" icon="icon-add"
              @click="this.addLineItemId" @input="lineItemInput" @enter="this.addLineItemId">
          </InputFloatLabel>
          <div class="bubbleContainer" ref="lineItem-wrapper">
            <InfoBubble @bubbleDeleted="deleteLineItem" v-for="singleLineItem in this.lineItems"
                        :key="mediumIndex+'-'+index+'-'+singleLineItem.admanager_id" color="blue"
                        :isFilled=true
                        :value="singleLineItem.admanager_id"></InfoBubble>
          </div>
        </div>

        <div class="items last">
          <InputFloatLabel
              icon-size="1.8em" :value="this.creativeId" label="AdManager Creative IDs" icon="icon-add"
              @click="this.addCreativeId" @enter="this.addCreativeId" @input="creativeInput">
          </InputFloatLabel>
          <div class="bubbleContainer" ref="creative-wrapper">
            <InfoBubble @bubbleDeleted="deleteCreative" v-for="singleCreative in this.creatives"
                        :key="mediumIndex+'-'+index+'-'+singleCreative.admanager_id" color="blue"
                        :isFilled=true
                        :value="singleCreative.admanager_id"></InfoBubble>
          </div>
        </div>
      </div>
      <div v-else class="itemWrapper automaticLineItemRetrieve">
        <div class="items">
          <InputFloatLabel
              icon-size="1.8em" :value="this.lineItemId" label="AdManager LineItem IDs" icon="icon-add"
              @click="this.addLineItemId" @input="lineItemInput" @enter="this.addLineItemId">
          </InputFloatLabel>
          <div class="bubbleContainer" ref="lineItem-wrapper">
            <InfoBubble @bubbleDeleted="deleteLineItem" v-for="singleLineItem in this.lineItems"
                        :key="mediumIndex+'-'+index+'-'+singleLineItem.admanager_id" color="blue"
                        :isFilled=true
                        :value="singleLineItem.admanager_id"></InfoBubble>
          </div>
        </div>
        <div class="items last">
          <div v-if="adSpecial === 28" class="additionalDates bubbleContainer">
            <div class="dashboard-date-heading"><span>Dashboard Laufzeit hinzufügen:</span>
              <DatePicker class="icon" :only-icon="true"
                          @close="dashboardDatePickerClosed"></DatePicker>
            </div>
            <InfoBubble @bubbleDeleted="deleteDashboardRange" v-for="date in this.dashboard_dates"
                        :key="'dashboard-'+mediumIndex+'-'+index+'-'+date.start+'-'+date.end" color="blue"
                        :isFilled=true
                        :value="formatDate(date.start) + ' - ' + formatDate(date.end)"></InfoBubble>
          </div>
        </div>
      </div>
      <div class="iconBoxContainer">
        <IconBox class="iconBox" @addItem="addInsertionOrder" @deleteItem="deleteInsertionOrder"
                 :copy=false></IconBox>
      </div>
    </div>
  </div>


</template>

<script>
import DatePicker from "../../../components/datePicker/DatePicker";
import Dialog from "../../../components/dialog/Dialog";
import InputFloatLabel from "../../../components/inputs/InputFloatLabel";
import InfoBubble from "../../../components/inputs/InfoBubble";
import IconBox from "./IconBox";
import ComboBox from "./ComboBox";
import moment from 'moment';
import InputDetail from "../../../components/inputs/InputDetail";
import SubmitButton from "../../../components/buttons/SubmitButton";


export default {
  name: "InsertionOrder",
  components: {
    SubmitButton,
    InputDetail, ComboBox, IconBox, InfoBubble, InputFloatLabel, Dialog, DatePicker
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    mediumIndex: {
      type: Number,
      required: true
    },
    sitesOnly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    }

  },
  data() {
    return {
      invalidSites: [],
      site: '',
      siteValidationLoading: false,
      secondLevelSiteValidationLoading: false,
      showConfirmMedium: false,
      creativeId: '',
      lineItemId: '',
      showSitesDialog: false,
      currentFirstLevelSite: null,
      currentSecondLevelSite: null
    };
  },
  computed: {

    allSites() {
      return this.$store.state.sites.sites;
    },
    categories() {
      return this.$store.state.sites.categories;
    },
    categoriesLoading() {
      return this.$store.state.sites.categoriesLoading;
    },
    insertionOrder() {
      return this.$store.state.campaign.campaign.mediums[this.mediumIndex].insertion_order[this.index];
    },
    adSpecial() {
      return this.$store.state.campaign.campaign.ad_special_id;
    },
    lineItems() {
      return this.insertionOrder.line_items;
    },
    creatives() {
      return this.insertionOrder.creatives;
    },
    dates() {
      return this.insertionOrder.dates;
    },
    dashboard_dates() {
      return this.insertionOrder.dashboard_dates;
    },
    sites() {
      return this.insertionOrder.sites;
    },
    automaticLineItemRetrieve() {
      return this.$store.state.campaign.automaticLineItemRetrieve;
    }
  },
  methods: {
    openSitesDialog() {
      this.showSitesDialog = true;
    },
    closeSitesDialog() {
      this.showSitesDialog = false;
    },
    datePickerClosed: function (range) {
      this.$store.commit('campaign/addRange', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'range': range
      })
    },
    dashboardDatePickerClosed: function (range) {
      this.$store.commit('campaign/addRange', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'range': range,
        'dashboard_dates': true
      })
    },
    addCreativeId: function () {
      if (this.creativeId !== '') {
        if (!isNaN(this.creativeId)) {
          this.$store.commit('campaign/addCreativeId', {
            'mediumIndex': this.mediumIndex,
            'index': this.index,
            'id': this.creativeId
          });
          this.creativeId = '';
        } else {
          this.$noty.error('ungültige Creative ID');
        }
      } else {
        this.$noty.error('Creative ID darf nicht leer sein');
      }
    },
    creativeInput: function (value) {
      this.creativeId = value;
    },
    addLineItemId: function () {
      if (this.lineItemId !== '') {
        if (!isNaN(this.lineItemId)) {
          this.$store.commit('campaign/addLineItemId', {
            'mediumIndex': this.mediumIndex,
            'index': this.index,
            'id': this.lineItemId
          });
          this.lineItemId = '';
        } else {
          this.$noty.error('ungültige Line Item ID');
        }
      } else {
        this.$noty.error('Line Item ID darf nicht leer sein');
      }
    },
    lineItemInput: function (value) {
      this.lineItemId = value;
    },
    addSite: async function (site) {
      try {
        this.siteValidationLoading = true;
        this.$store.commit('campaign/addSite', {
          'mediumIndex': this.mediumIndex,
          'index': this.index,
          'site': site
        });
        this.siteValidationLoading = false;
      } catch (e) {
        this.siteValidationLoading = false;
        this.$noty.error('Es ist ein Fehler aufgetreten');
      }
    },
    addSecondLevelSite: async function () {
      try {
        if ((!this.currentSecondLevelSite || Object.keys(this.currentSecondLevelSite).length === 0) &&
            (!this.currentFirstLevelSite || Object.keys(this.currentFirstLevelSite).length === 0)) {
          this.$noty.error('Keine gültige Seite ausgewählt.');
          return;
        }
        this.secondLevelSiteValidationLoading = true;
        let site = this.currentSecondLevelSite && Object.keys(this.currentSecondLevelSite).length > 0 ? this.currentSecondLevelSite : this.currentFirstLevelSite;
        this.$store.commit('campaign/addSite', {
          'mediumIndex': this.mediumIndex,
          'index': this.index,
          'site': site
        });
        this.secondLevelSiteValidationLoading = false;
        this.currentFirstLevelSite = null;
        this.currentSecondLevelSite = null;
      } catch (e) {
        this.secondLevelSiteValidationLoading = false;
        this.$noty.error('Es ist ein Fehler aufgetreten');
      }
    },
    changeFirstLevelSite(value) {
      this.currentFirstLevelSite = value;
      this.currentSecondLevelSite = null;
    },
    changeSecondLevelSite(value) {
      this.currentSecondLevelSite = value;
    }
    ,
    siteInput: function (value) {
      this.site = value;
    }
    ,
    formatDate: function (date) {
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YY')
    }
    ,
    addInsertionOrder() {
      this.$store.commit('campaign/addInsertionOrder', {'index': this.mediumIndex, 'type': this.type});
    }
    ,
    deleteInsertionOrder() {
      this.$store.commit('campaign/deleteInsertionOrder', {
        'mediumIndex': this.mediumIndex,
        'index': this.index
      });
    }
    ,
    deleteSite(site, siteIndex) {
      this.$store.commit('campaign/removeSite', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'siteIndex': siteIndex,
        'site': site
      });
    }
    ,
    deleteRange(range) {
      this.$store.commit('campaign/removeRange', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'range': range
      });
    },
    deleteDashboardRange(range) {
      this.$store.commit('campaign/removeRange', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'range': range,
        'dashboard_dates': true
      });
    }
    ,
    deleteCreative(creative) {
      this.$store.commit('campaign/removeCreative', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'creative': creative
      });
    }
    ,
    deleteLineItem(lineItem) {
      this.$store.commit('campaign/removeLineItem', {
        'mediumIndex': this.mediumIndex,
        'index': this.index,
        'lineItem': lineItem
      });
    }
    ,
    siteAlreadyExists(site) {
      for (let i = 0; i < this.sites.length; i++) {
        if (this.sites[i].name === site) {
          return true;
        }
      }
      return false;
    }
    ,
    isValidSite(site) {
      for (let i = 0; i < this.allSites.length; i++) {
        let name = typeof site.edited !== 'undefined' ? site.edited : site.name;
        if (name.indexOf(this.allSites[i].name) !== -1) {
          return true;
        }
      }
      return false;
    },
    getSecondLevels(firstLevelUnit) {
      this.changeFirstLevelSite(firstLevelUnit);
      if (typeof firstLevelUnit.id !== 'undefined' && firstLevelUnit.id !== null) {
        this.$store.commit('sites/setCategories', {parentId: firstLevelUnit.id});
      }

    }
  }
}
</script>

<style lang="scss" scoped>
.itemWrapper {
  display: flex;
}

.items {
  display: inline-block;
  width: 23.5%;
  margin-right: 2%;
}

.items.last {
  margin-right: 0;
}

.items:last-child {
  margin-right: 0;
}

.bubbleContainer {
  padding-top: .3rem;
}

.loader {
  border: 3px solid;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border-color: $pink transparent transparent;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin: .3rem;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
    filter: hue-rotate(360deg)
  }
}

.iconBoxContainer {
  display: block;
  width: 100%;
  padding-bottom: 1rem;
  padding-top: .5rem;
}

.iconBox {
  float: right;
}

.dialogHeader {
  width: 100%;
  display: block;
}

.dropdownWrapperSites {
  width: 100%;
  display: block;
}

.combobox {
  display: inline-block;
  padding-right: 1rem;
}

.createdContainer {
  width: 100%;
  border-top: 1px $grey solid;
  font-size: .6em;
  margin-top: 2rem;
  padding-top: .5rem;
}

.submitSecondLevelSites {
  margin-top: 2rem;
}

.secondLevelBubbles {
  font-size: 1.7em !important;
  max-width: 100%;
}

.dashboard-date-heading {
  font-size: .8rem;
  margin-bottom: .2rem;
}

.icon {
  cursor: pointer;
  font-size: 1.1em;
  display: inline-block;
  margin-left: .5em;
}

</style>